import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import About from './About';
import Projects from './Projects';
import Awards from './Awards';
import Pinnacles from './Pinnacles';
import Judges from './Judges';
import Speakers from './Speakers';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  panel: {
    padding: theme.spacing(3)
  },
  label: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.7em',
      lineHeight: '1.5em',
      minWidth: '80px'
    },
  }
}));

const components = {
  about: About,
  projects: Projects,
  awards: Awards,
  pinnacles: Pinnacles,
  judges: Judges,
  speakers: Speakers
};

const TabContent = (props) => {
  const Component = components[props.config.id];
  return <Component config={props.config} key={props.config.id} />;
}

export default (props) => {
  const [value, setValue] = React.useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles();
  return (
    <>
    <AppBar position="static" className={classes.root}>
      <Tabs value={value} textColor="primary" indicatorColor="secondary" variant="fullWidth" scrollButtons="auto" centered onChange={handleChange}>
        { props.config.content.tabs.map( (tab, index) => (
          <Tab id={`tab-${props.config.id}-${tab.id}`} aria-controls={`tabpanel-${props.config.id}-${tab.id}`} label={tab.name} key={tab.id} className={classes.label} />
        ))}
      </Tabs>
    </AppBar>
    <div  >
    <Container>
    { props.config.content.tabs.map( (tab, index) => (
      <div hidden={value !== index} role="tabpanel" id={`tabpanel-${props.config.id}-${tab.id}`} aria-labelledby={`tab-${props.config.id}-${tab.id}`} key={`tab-${props.config.id}-${tab.id}`} className={classes.panel}>
        { value === index && (
          <TabContent config={tab} key={`content-${props.config.id}-${tab.id}`}  />
        )}
      </div>
    ))}
    </Container>
    </div>
    </>
  );
}